module.exports = __webpack_public_path__ + "media/images/flags/4x3/ago-dcf1e966ecfe4e0258dd974e86de5058.svg";